/* eslint-disable max-len */
import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const ClockIcon: FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0001 2.16669C14.6025 2.16669 18.3334 5.89765 18.3334 10.5C18.3334 15.1024 14.6025 18.8334 10.0001 18.8334C5.39771 18.8334 1.66675 15.1024 1.66675 10.5C1.66675 5.89765 5.39771 2.16669 10.0001 2.16669ZM9.99998 3.83333C6.31808 3.83333 3.33331 6.8181 3.33331 10.5C3.33331 14.1819 6.31808 17.1667 9.99998 17.1667C13.6819 17.1667 16.6666 14.1819 16.6666 10.5C16.6666 6.8181 13.6819 3.83333 9.99998 3.83333ZM10.0001 5.49997C10.4274 5.49997 10.7797 5.82167 10.8278 6.23612L10.8334 6.3333V10.1548L12.256 11.5774C12.5814 11.9028 12.5814 12.4305 12.256 12.7559C11.9556 13.0563 11.4829 13.0794 11.156 12.8252L11.0775 12.7559L9.41083 11.0892C9.28059 10.959 9.19792 10.7901 9.17397 10.6095L9.16675 10.5V6.3333C9.16675 5.87307 9.53984 5.49997 10.0001 5.49997Z"
      fill="#7B10FD"
    />
  </svg>
);
